module.exports = __webpack_public_path__ + "img/noimg.7422f5e8.png";